import type { IconProps } from './IconsTypes'

export const GooglePayIcon = ({
  width = 55,
  height = 29,
  viewBox = '0 0 55 29',
  color = '#3C4043',
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40.02 0H14.5C6.525 0 0 6.525 0 14.5C0 22.475 6.525 29 14.5 29H40.02C47.995 29 54.52 22.475 54.52 14.5C54.52 6.525 47.995 0 40.02 0Z"
      fill="white"
    />
    <path
      d="M40.02 1.1745C41.8107 1.1745 43.5507 1.52975 45.1892 2.22575C46.777 2.9 48.198 3.86425 49.4305 5.0895C50.6557 6.31475 51.62 7.743 52.2942 9.33075C52.9902 10.9693 53.3455 12.7092 53.3455 14.5C53.3455 16.2908 52.9902 18.0307 52.2942 19.6692C51.62 21.257 50.6557 22.678 49.4305 23.9105C48.2052 25.1357 46.777 26.1 45.1892 26.7742C43.5507 27.4702 41.8107 27.8255 40.02 27.8255H14.5C12.7093 27.8255 10.9692 27.4702 9.33075 26.7742C7.743 26.1 6.322 25.1357 5.0895 23.9105C3.86425 22.6852 2.9 21.257 2.22575 19.6692C1.52975 18.0307 1.1745 16.2908 1.1745 14.5C1.1745 12.7092 1.52975 10.9693 2.22575 9.33075C2.9 7.743 3.86425 6.322 5.0895 5.0895C6.31475 3.86425 7.743 2.9 9.33075 2.22575C10.9692 1.52975 12.7093 1.1745 14.5 1.1745H40.02ZM40.02 0H14.5C6.525 0 0 6.525 0 14.5C0 22.475 6.525 29 14.5 29H40.02C47.995 29 54.52 22.475 54.52 14.5C54.52 6.525 47.995 0 40.02 0Z"
      fill="#3C4043"
    />
    <path
      d="M25.9984 15.5302V19.9165H24.6064V9.08496H28.2967C29.2319 9.08496 30.0294 9.39671 30.6819 10.0202C31.3489 10.6437 31.6824 11.405 31.6824 12.304C31.6824 13.2247 31.3489 13.986 30.6819 14.6022C30.0367 15.2185 29.2392 15.523 28.2967 15.523H25.9984V15.5302ZM25.9984 10.419V14.1962H28.3257C28.8767 14.1962 29.3407 14.0077 29.7032 13.638C30.0729 13.2682 30.2614 12.8187 30.2614 12.3112C30.2614 11.811 30.0729 11.3687 29.7032 10.999C29.3407 10.6147 28.8839 10.4262 28.3257 10.4262H25.9984V10.419Z"
      fill="#3C4043"
    />
    <path
      d="M35.3221 12.2598C36.3516 12.2598 37.1636 12.5353 37.7581 13.0863C38.3526 13.6373 38.6499 14.3913 38.6499 15.3483V19.9158H37.3231V18.8863H37.2651C36.6924 19.7345 35.9239 20.155 34.9669 20.155C34.1476 20.155 33.4661 19.9158 32.9151 19.43C32.3641 18.9443 32.0886 18.3425 32.0886 17.6175C32.0886 16.849 32.3786 16.24 32.9586 15.7905C33.5386 15.3338 34.3144 15.109 35.2786 15.109C36.1051 15.109 36.7866 15.2613 37.3159 15.5658V15.2468C37.3159 14.761 37.1274 14.355 36.7431 14.0143C36.3589 13.6735 35.9094 13.5068 35.3946 13.5068C34.6189 13.5068 34.0026 13.833 33.5531 14.4928L32.3279 13.7243C33.0021 12.7455 34.0026 12.2598 35.3221 12.2598ZM33.5241 17.6393C33.5241 18.0018 33.6764 18.3063 33.9881 18.5455C34.2926 18.7848 34.6551 18.908 35.0684 18.908C35.6556 18.908 36.1776 18.6905 36.6344 18.2555C37.0911 17.8205 37.3231 17.313 37.3231 16.7258C36.8881 16.385 36.2864 16.211 35.5106 16.211C34.9451 16.211 34.4739 16.3488 34.0969 16.617C33.7126 16.8998 33.5241 17.2405 33.5241 17.6393Z"
      fill="#3C4043"
    />
    <path
      d="M46.2186 12.499L41.5786 23.171H40.1431L41.8686 19.4373L38.8091 12.499H40.3243L42.5283 17.8205H42.5573L44.7033 12.499H46.2186Z"
      fill="#3C4043"
    />
    <path
      d="M20.4618 14.6446C20.4618 14.1907 20.4212 13.7565 20.3458 13.3389H14.511V15.7314L17.8714 15.7321C17.7351 16.5281 17.2964 17.2067 16.6244 17.6591V19.2114H18.6246C19.7926 18.1304 20.4618 16.5325 20.4618 14.6446Z"
      fill="#4285F4"
    />
    <path
      d="M16.6252 17.6598C16.0684 18.0353 15.3513 18.255 14.5125 18.255C12.8921 18.255 11.5175 17.1632 11.0253 15.6914H8.96191V17.2922C9.98416 19.3208 12.0852 20.7128 14.5125 20.7128C16.1902 20.7128 17.5996 20.161 18.6254 19.2113L16.6252 17.6598Z"
      fill="#34A853"
    />
    <path
      d="M10.831 14.5039C10.831 14.0907 10.8999 13.6912 11.0253 13.3156V11.7148H8.96199C8.53931 12.5537 8.30151 13.5005 8.30151 14.5039C8.30151 15.5073 8.54004 16.4542 8.96199 17.293L11.0253 15.6922C10.8999 15.3166 10.831 14.9172 10.831 14.5039Z"
      fill="#FABB05"
    />
    <path
      d="M14.5125 10.7517C15.4282 10.7517 16.2482 11.0671 16.8956 11.6833L18.6682 9.91215C17.5916 8.90947 16.188 8.29395 14.5125 8.29395C12.0859 8.29395 9.98416 9.68594 8.96191 11.7145L11.0253 13.3153C11.5175 11.8435 12.8921 10.7517 14.5125 10.7517Z"
      fill="#E94235"
    />
  </svg>
)
